<script setup>
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    title: String,
    href: String,
});

const { t: __ } = useI18n();

onMounted(() => {
    if (!document.getElementById("oto-twitter-script")) {
        let twitterScript = document.createElement("script");
        twitterScript.id = "oto-twitter-script";
        twitterScript.setAttribute("src", "https://platform.twitter.com/widgets.js");
        twitterScript.setAttribute("async", true);
        twitterScript.setAttribute("charset", "utf-8");
        document.head.appendChild(twitterScript);
    }
});
</script>
<template>
    <blockquote class="twitter-tweet" data-media-max-width="560">
        <a :href="href"></a>
    </blockquote>
</template>
